import "core-js/modules/es6.reflect.construct.js";
import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import _classCallCheck from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _get from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/get.js";
import _inherits from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// User Model
import VuexORM from '@vuex-orm/core';
import TodoList from 'src/store/models/TodoList';
import Tag from 'src/store/models/Tag';
import TagTodo from 'src/store/models/TagTodo';
import Vue from 'vue';
import Integration from 'src/store/models/Integration';

var Todo = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Todo, _VuexORM$Model);

  var _super = _createSuper(Todo);

  function Todo() {
    _classCallCheck(this, Todo);

    return _super.apply(this, arguments);
  }

  _createClass(Todo, [{
    key: "canDelete",
    value: function canDelete(userId) {
      var todo = Todo.query().where('todo_id', this.todo_id).with(['todo_list.project', 'users']).first();
      var todoList = todo.todo_list;
      var project = todoList === null || todoList === void 0 ? void 0 : todoList.project;
      return ( // If the todo is not in a list (Personal todos)
      !todoList || ( // OR if the user can edit the project
      project === null || project === void 0 ? void 0 : project.canEdit(userId)) || // OR if the user is the creator and the todo is not assigned to other users
      this.user_id === userId && !todo.users.filter(function (user) {
        return user.user_id !== userId;
      }).length) && ( // AND
      // the todo is not linked to an integration
      !todo.integration_code || // OR the integration linked to the todo has the TasksWrite feature
      todo.integration_code && Integration.query().all().filter(function (integration) {
        return integration.features.reduce(function (acc, feature) {
          return acc || feature === 'TasksWrite';
        }, false);
      }).map(function (integration) {
        return integration.integration_code;
      }).includes(todo.integration_code));
    }
  }], [{
    key: "entity",
    get: // This is the name used as module name of the Vuex Store.
    function get() {
      return 'todos';
    }
  }, {
    key: "primaryKey",
    get: function get() {
      return 'todo_id';
    }
  }, {
    key: "fields",
    value: // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    function fields() {
      return {
        todo_id: this.number(null),
        todo_list_id: this.number(null).nullable(),
        todo_list: this.belongsTo(TodoList, 'todo_list_id'),
        user_id: this.number(null).nullable(),
        account_id: this.attr(null),
        project_id: this.attr(null),
        name: this.attr(''),
        description: this.attr(''),
        index: this.number(null),
        integration_url: this.attr(''),
        integration_code: this.attr(''),
        integration_todo_id: this.attr(null),
        integration_todo_list_id: this.attr(null),
        integration_status: this.attr(null),
        integration: this.belongsTo(Integration, 'integration_code'),
        start_date: this.attr(''),
        due_date: this.attr(''),
        status: this.attr(''),
        priority: this.attr('medium'),
        is_personal: this.number(1),
        total_time: this.attr(''),
        users: this.attr([]),
        // not a relationship on purpose, people attached to a todo can be seen by everyone but not put in store if not necessary
        tags: this.belongsToMany(Tag, TagTodo, 'todo_id', 'tag_id'),
        users_with_entries: this.attr([]),
        estimated_time: this.attr(null),
        created_at: this.attr(null)
      };
    }
  }, {
    key: "insertAtIndex",
    value: function insertAtIndex(todo) {
      var todoList = TodoList.find(todo.todo_list_id);
      todoList.increaseTodosCount(todo.status === 'completed');
      this.query().where('todo_list_id', parseInt(todo.todo_list_id)).where('index', function (value) {
        return value >= todo.index;
      }).get().forEach(function (todo) {
        Todo.update({
          where: todo.todo_id,
          data: {
            index: todo.index + 1
          }
        });
      });
    }
  }, {
    key: "lastUpdatedAt",
    get: function get() {
      return this.store().state.entities.todos.last_updated_at;
    }
  }, {
    key: "moveToIndex",
    value: function moveToIndex(todoId, data) {
      var oldTodo = Todo.find(todoId);

      if (!oldTodo) {
        return;
      }

      var oldTodoList = TodoList.find(oldTodo.todo_list_id);

      if (data.todo_list_id && oldTodo.todo_list_id !== data.todo_list_id) {
        // if the todo list has changed we need to update old todos
        oldTodoList.decreaseTodosCount(oldTodo.status === 'completed');
        this.query().where('todo_list_id', oldTodo.todo_list_id).where('index', function (value) {
          return value > oldTodo.index;
        }) // oldIndex
        .get().forEach(function (todo) {
          Todo.update({
            where: todo.todo_id,
            data: {
              index: todo.index - 1
            }
          });
        }); // add to new todoList

        this.insertAtIndex(data);
      } else if (data.index !== oldTodo.index) {
        var movedForward = data.index > oldTodo.index;
        this.query().where('todo_list_id', data.todo_list_id).where('index', function (value) {
          if (movedForward) {
            return value <= data.index && value > oldTodo.index;
          } else {
            return value >= data.index && value < oldTodo.index;
          }
        }).get().forEach(function (todo) {
          Todo.update({
            where: todo.todo_id,
            data: {
              index: movedForward ? --todo.index : ++todo.index
            }
          });
        });
      }

      if (data.status && oldTodo.status !== data.status) {
        oldTodoList.decreaseTodosCount(oldTodo.status === 'completed');
        oldTodoList.increaseTodosCount(data.status === 'completed');
      } // update old todo


      if (oldTodo) {
        var oldTodoListId = oldTodo.todo_list_id;
        Todo.update({
          where: oldTodo.todo_id,
          data: data
        }).then(function () {
          Vue.prototype.$eventHub.$emit("todo-list-".concat(data.todo_list_id, "-changed"));
          Vue.prototype.$eventHub.$emit("todo-list-".concat(oldTodoListId, "-changed"));
        });
      }
    }
  }, {
    key: "insertOrUpdate",
    value: function insertOrUpdate(_ref) {
      var data = _ref.data;
      return _get(_getPrototypeOf(Todo), "insertOrUpdate", this).call(this, {
        data: data
      }).then(function () {
        var todoListIds = [];

        if (Array.isArray(data)) {
          // sets doesn't allow duplicates, used to filter duplicated todo_list ids
          todoListIds = _toConsumableArray(new Set(data.map(function (todo) {
            return todo.todo_list_id;
          })));
        } else if (data.todo_list_id) {
          todoListIds = [data.todo_list_id];
        }

        todoListIds.forEach(function (todoListId) {
          setTimeout(function () {
            Vue.prototype.$eventHub.$emit("todo-list-".concat(todoListId, "-changed"));
          }, 100);
        });
      });
    }
  }, {
    key: "deleteById",
    value: function deleteById(todoId) {
      var todo = Todo.find(todoId);
      if (!todo) return; // the todo could be already deleted

      var todoList = TodoList.find(todo.todo_list_id);
      todoList.decreaseTodosCount(todo.status === 'completed');

      if (todo) {
        this.query().where('todo_list_id', parseInt(todo.todo_list_id)).where('index', function (value) {
          return value >= todoId.index;
        }).get().forEach(function (todoId) {
          todoId.index--;
          todoId.$save();
        });
      }

      return _get(_getPrototypeOf(Todo), "delete", this).call(this, todoId).then(function () {
        Vue.prototype.$eventHub.$emit("todo-list-".concat(todo.todo_list_id, "-changed"));
      });
    }
  }]);

  return Todo;
}(VuexORM.Model);

_defineProperty(Todo, "state", {
  last_updated_at: null
});

_defineProperty(Todo, "apiConfig", {
  actions: {
    fetch: function fetch(data) {
      return this.post('/get-todos', data).then(function (result) {
        return result;
      });
    },
    fetchById: function fetchById(id) {
      return this.get("/todos/".concat(id)).then(function (result) {
        return result;
      });
    },
    store: function store(data) {
      return this.post('/todos', data).then(function (result) {
        Todo.commit(function (state) {
          state.last_updated_at = Date.now();
        });
        return result;
      });
    },
    update: function update(id, data) {
      var save = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return this.put("/todos/".concat(id), data, {
        save: save
      }).then(function (result) {
        Todo.commit(function (state) {
          state.last_updated_at = Date.now();
        });
        return result;
      });
    },
    sync: function sync(id) {
      return this.put("/todos/".concat(id, "/sync")).then(function (result) {
        Todo.commit(function (state) {
          state.last_updated_at = Date.now();
        });
        return result;
      });
    },
    destroy: function destroy(id) {
      return this.delete("/todos/".concat(id)).then(function () {
        Todo.deleteById(id).then(function () {
          TodoList.commit(function (state) {
            state.last_updated_at = Date.now();
          });
        });
      });
    },
    getEstimateLog: function getEstimateLog(id) {
      return this.get("/todos/".concat(id, "/estimate-log")).then(function (result) {
        return result;
      });
    }
  }
});

export { Todo as default };